import React, { Component } from "react";
import Img from "react-image";
import _ from "lodash";
import moment from "moment";
import ClassNames from "classnames";
import { connect } from "react-redux";
import { iconEVENTSwitch } from "../../../../../ReactConst2";
import { getHistoEventSimple } from "../les-tabs-ducks/HistoEvent.ducks";
import { getArriveEvent } from "../../modals/modal-enfant/les-tabs-ducks/Arrive.ducks";
import { getSanteEvent } from "../../modals/modal-enfant/les-tabs-ducks/Sante.ducks";
import { getPetitCoinEvent } from "../../modals/modal-enfant/les-tabs-ducks/Petitcoin.ducks";
import { getRepasEvent } from "../../modals/modal-enfant/les-tabs-ducks/Repas.ducks";
import { getSiesteEvent } from "../../modals/modal-enfant/les-tabs-ducks/Sieste.ducks";
import { getActiviteEvent } from "../../modals/modal-enfant/les-tabs-ducks/Activite.ducks";
import { getDepartEvent } from "../../modals/modal-enfant/les-tabs-ducks/Depart.ducks";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import InfiniteScroll from "react-infinite-scroll-component";
import ModalWarning from "./ModalWarning";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/moment";
import { Service } from "../../../../service/service";
import { API } from "../../../../../const";
import { withTranslation } from 'react-i18next';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
const divStyleScroll = {
  overflow: "none",
};
const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});
class HistoEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      offset: 1,
      historyPerPage: 40,
      msgsLoading: true,
      scrollLoader: false,
      page: 1,
      startDate: null,
      endDate: null,
      errorExport: false,
      pdfFile: "",
      msgErreur: "",
      modalwarning: false,
      hasMoreItems: true,
      loadingPDF: false,
    };
    this.loadMore = this.loadMore.bind(this);
    this.handleClickViewEvent = this.handleClickViewEvent.bind(this);
    this.handleChangeDateStart = this.handleChangeDateStart.bind(this);
    this.handleChangeDateEnd = this.handleChangeDateEnd.bind(this);
    this.exportFile = this.exportFile.bind(this);
    this.onClose = this.onClose.bind(this);
    this.errorClass = this.errorClass.bind(this);
  }

  onClose = (event) => {
    event.preventDefault();

    this.setState({
      modalwarning: false,
    });
  };

  exportFile = () => {
    var time1 = moment(this.state.startDate).format("YYYY-MM-DD");
    var time2 = moment(this.state.endDate).format("YYYY-MM-DD");

    var difference = moment(this.state.endDate).diff(
      moment(this.state.startDate),
      "month",
      true
    );

    if (difference > 3) {
      this.setState({
        modalwarning: true,
      });
    } else {
      this.setState({
        loadingPDF: true,
      });
      let id = window.location.pathname.match(/\d+/g)[0];
      let datedebut = moment(this.state.startDate).format("YYYY-MM-DD");
      let datefin = moment(this.state.endDate).format("YYYY-MM-DD");

      let tok = localStorage.getItem("token");
      const response = Service.get(
        `${API}api/enfant/creche/enfants/${id}/historiques/extractions?date-debut=${datedebut}&date-fin=${datefin}`,
        {
          headers: {
            Authorization: `Bearer ${tok}`,
            Accept: "application/pdf",
          },
          "Content-Type": "application/pdf",
          responseType: "blob",
        }
      );
      response.then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        var time1 = moment(this.state.startDate).format("YYYY-MM-DD");
        var time2 = moment(this.state.endDate).format("YYYY-MM-DD");
        var fileName =
          "historique-" +
          this.props.kidItem.prenom +
          "-" +
          this.props.kidItem.nom +
          "-de-" +
          time1 +
          "-a-" +
          time2 +
          ".pdf";
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        this.setState({
          loadingPDF: false,
        });
      });
      response.catch((err) => {});
    }
  };

  handleChangeDateStart = (date) => {
    this.setState({
      startDate: date,
      msgErreur: "",
    });
  };
  errorClass(error) {
    return _.isEmpty(error) ? "" : "error-mess";
  }
  handleChangeDateEnd = (date) => {
    var time1 = moment(this.state.startDate).format("YYYY-MM-DD");
    var time2 = moment(date).format("YYYY-MM-DD");
    if (time2 > time1) {
      var difference = moment(date).diff(
        moment(this.state.startDate),
        "month",
        true
      );
      this.setState({
        errorExport: false,
        msgErreur: "",
      });
    } else if (time2 < time1) {
      this.setState({
        errorExport: true,
        msgErreur: this.props.t('validation.end_date_before_start'),
      });
    } else {
      this.setState({
        errorExport: false,
        msgErreur: "",
      });
    }
    this.setState({
      endDate: date,
    });
  };

  componentDidMount() {
    let tok = localStorage.getItem("token");
    let id = window.location.pathname.match(/\d+/g)[0];
    const response = Service.get(
      `${API}api/enfant/creche/enfants/${id}/historiques?offset=1&path-size=30`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      let sortedKids = res.data.historique.elements.sort((a, b) =>
        moment(b.dateTime).diff(a.dateTime)
      );
      this.setState({
        history: sortedKids,
        msgsLoading: false,
        page: res.data.historique.pagesNumber,
        totalElements: res.data.historique.totalElements,
      });
    });
  }
  loadMore() {
    this.setState({
      scrollLoader: true,
    });
    if (this.state.history.length === this.state.totalElements) {
      this.setState({ hasMoreItems: false });
    } else {
      setTimeout(() => {
        let tok = localStorage.getItem("token");
        let offset = this.state.offset + 1;
        let id = window.location.pathname.match(/\d+/g)[0];

        const response = Service.get(
          `${API}api/enfant/creche/enfants/${id}/historiques?offset=${offset}&path-size=30`,
          { headers: { Authorization: `Bearer ${tok}` } }
        );
        response.then((res) => {
          let sortedKids = this.state.history.concat(
            res.data.historique.elements
          );
          sortedKids = sortedKids.sort((a, b) =>
            moment(b.dateTime).diff(a.dateTime)
          );
          this.setState({
            history: sortedKids,
            offset: offset,
            scrollLoader: false,
          });
        });
      }, 500);
    }
  }
  handleClickViewEvent(event) {
    let typeEvent = event.typeEvent;
    let tabToView;
    switch (typeEvent) {
      case "ARRIVEE":
        {
          tabToView = "arrivee-tab";
          //Dispatch getEventArrivee
          this.props.getArriveEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "ACTIVITE":
      case "PATE_A_MODELER":
      case "PEINTURE":
      case "PEINTURE":
      case "DANSE":
      case "PEINTURE":
      case "SORTIE":
      case "PISCINE":
      case "LECTURE":
      case "ACTIVITE_MANUELLE":
      case "AUTRE":
        {
          tabToView = "activite-tab";
          this.props.getActiviteEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "DEPART":
        {
          tabToView = "depart-tab";
          this.props.getDepartEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "ABSENCE":
        {
          tabToView = "absence-tab";
          this.props.getArriveEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "INCIDENT":
      case "FIEVRE":
      case "VOMI":
      case "TOUX":
      case "BLESSURE":
      case "BOUTONS":
      case "AUTRE":
        {
          tabToView = "sante-tab";
          this.props.getSanteEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "SIESTE":
        {
          tabToView = "sieste-tab";
          this.props.getSiesteEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "REPAS":
      case "BIBERON":
      case "REPAS_PEU":
      case "REPAS_CORRECTEMENT":
      case "REPAS_BEAUCOUP":
        {
          tabToView = "repas-tab";
          this.props.getRepasEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      case "PETITCOIN":
      case "PETITE_COMMISSION":
      case "GROSSE_COMMISSION":
        {
          tabToView = "petitcoin-tab";
          this.props.getPetitCoinEvent(
            localStorage.getItem("token"),
            event.idEvent
          );
        }
        break;
      default:
        break;
    }
    if (typeEvent !== "NEXT_BIBERON")
      this.props.toViewEvent(tabToView, event.idEvent);
  }
  renderInput = (props) => (
    <input
      readOnly
      className="form-control ipt-id-naissance"
      type="text"
      onClick={props.onClick}
      id={props.id}
      value={props.textLabel + props.value}
      {...props.inputProps}
    />
  );

  render() {
    return (
      <div
        className="tab-pane show active"
        id="historique-evenements-pane"
        role="tabpanel"
        aria-labelledby="historique-evenements-tab"
      >
        <div className="content p-0">
          <section class="content-section border-0">
            <h2 className="mt-2">{this.props.t('fiche_enfant.histo.export_history')}</h2>
            <div class="row align-items-center row-horaires">
              <div class="col-md-6 pr-0">
                <div class="form-group">
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        autoOk
                        ampm={false}
                        value={this.state.startDate}
                        onChange={this.handleChangeDateStart}
                        format={"DD MMM YYYY "}
                        minutesStep={5}
                        TextFieldComponent={this.renderInput}
                        textLabel={this.props.t('fiche_enfant.histo.start_date') + "  "}
                        disabled={this.state.initialized}
                        strings={{ invalidInputErrorMessage: "Invalid date" }}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                  {(() => {
                    if (!_.isEmpty(this.state.msgErreur)) {
                      return (
                        <p
                          style={{
                            marginTop: "42px",
                          }}
                        >
                          {" "}
                        </p>
                      );
                    } else {
                      return "";
                    }
                  })()}
                </div>
              </div>
              <div class="col-md-6 pr-0">
                <div
                  className={`form-group ${this.errorClass(
                    this.state.msgErreur
                  )}`}
                >
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        autoOk
                        ampm={false}
                        value={this.state.endDate}
                        onChange={this.handleChangeDateEnd}
                        format={" DD MMM YYYY"}
                        minutesStep={5}
                        TextFieldComponent={this.renderInput}
                        disabled={this.state.initialized}
                        error={this.state.errorExport}
                        maxDate={moment().toDate()}
                        TextFieldComponent={this.renderInput}
                        textLabel={this.props.t('fiche_enfant.histo.end_date') + " "}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                  {(() => {
                    if (!_.isEmpty(this.state.msgErreur)) {
                      return <p>{this.state.msgErreur}</p>;
                    } else {
                      return "";
                    }
                  })()}
                </div>
              </div>
            </div>
          </section>
          <div className="d-flex justify-content-center mb-3">
            {this.state.loadingPDF == true ? (
              <DotLoader
                size={100}
                color={"#ff7d26"}
                css={override}
                loading={this.state.loadingPDF}
              />
            ) : (
              <button
                type="submit"
                id="ajouterJourFermeture"
                className="btn-blue mr-3"
                onClick={this.exportFile}
                disabled={
                  this.state.errorExport ||
                  this.state.startDate === null ||
                  this.state.endDate === null
                }
              >
                {this.props.t('fiche_enfant.histo.export_pdf')}
              </button>
            )}
          </div>
          {this.state.history.length>0 ? (
          <section className="content-section border-0 mb-0">
            <div class="fake-table-style">
              <div class="thead row">
                <div class="col-3" style={{ width: "20%" }}>
                  {this.props.t('fiche_enfant.histo.date')}
                </div>
                <div class="col-9">{this.props.t('fiche_enfant.histo.day_events')}</div>
              </div>
              <InfiniteScroll
                style={divStyleScroll}
                dataLength={this.state.history.length}
                next={this.loadMore}
                hasMore={this.state.hasMoreItems}
                loader={
                  <div className="content p-0">
                    <DotLoader
                      size={100}
                      color={"#ff7d26"}
                      css={override}
                      loading={this.state.msgsLoading}
                    />
                  </div>
                }
              >
                <OnePageHisto
                  history={this.state.history}
                  handleClickViewEvent={this.handleClickViewEvent}
                />
              </InfiniteScroll>
            </div>
          </section>
          ):null}
        </div>
        {this.state.modalwarning === true ? (
          <ModalWarning onClose={this.onClose} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  timelines: state.ficheEnfant.HistoEvent.data,
  loading: state.ficheEnfant.HistoEvent.loading,
});

export default connect(mapStateToProps, {
  getHistoEventSimple,
  getArriveEvent,
  getSanteEvent,
  getPetitCoinEvent,
  getRepasEvent,
  getSiesteEvent,
  getActiviteEvent,
  getDepartEvent,
})(withTranslation()(HistoEvent));

function OnePageHisto({ history, handleClickViewEvent }) {
  return (
    <div class="tbody">
      {history.map((timeline, index) => (
        <div class="tr row" key={index}>
          {_.isEmpty(timeline.date) ? (
            <div class="col-3"> {moment().format("DD/MM/YYYY")}</div>
          ) : (
            <div class="col-3">
              {" "}
              {moment(timeline.date).format("DD/MM/YYYY")}
            </div>
          )}
          <div class="col-9">
            {timeline.eventsEnfant.map((event) => (
              <span onClick={() => handleClickViewEvent(event)}>
                {iconEVENTSwitch(
                  event,
                  "28px",
                  "40px",
                  "icon-historique-evt",
                  handleClickViewEvent
                )}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

